<!--
~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
~ This software is the proprietary information of NEXTWELL INTL SRL.
~ Use is subject to license and non-disclosure terms
-->

<div class="row">
  <well-horizontal-scroll>
    @for (task of (this.$tasks | async)?.data; track task) {
      <div class="col-4 m-sm">
        <well-task-card-summary
          [task]="task"
          (solutionDeleted)="solutionDeleted.emit()">
        </well-task-card-summary>
      </div>
    }
  </well-horizontal-scroll>
</div>


